// App version tracking
export const APP_VERSION = '1.0.0';
export const APP_BUILD = '20260903';

// Check if the app needs updating
export const checkAppVersion = () => {
  const storedVersion = localStorage.getItem('app_version');
  const storedBuild = localStorage.getItem('app_build');
  
  const currentVersion = APP_VERSION;
  const currentBuild = APP_BUILD;
  
  // Check if stored version exists
  if (!storedVersion) {
    // First time - store current version
    localStorage.setItem('app_version', currentVersion);
    localStorage.setItem('app_build', currentBuild);
    return { isUpdate: false, current: currentVersion, stored: null };
  }
  
  // Check if version changed
  if (storedVersion !== currentVersion || storedBuild !== currentBuild) {
    return { 
      isUpdate: true, 
      current: currentVersion, 
      stored: storedVersion,
      build: currentBuild,
      storedBuild: storedBuild
    };
  }
  
  return { isUpdate: false, current: currentVersion, stored: storedVersion };
};

// Store current version after update
export const storeAppVersion = () => {
  localStorage.setItem('app_version', APP_VERSION);
  localStorage.setItem('app_build', APP_BUILD);
  localStorage.setItem('app_updated_at', new Date().toISOString());
};

// Get version display
export const getVersionDisplay = () => {
  return `v${APP_VERSION} (${APP_BUILD})`;
};

// Check if running as PWA (installed)
export const isPWAInstalled = () => {
  return window.matchMedia('(display-mode: standalone)').matches ||
         window.navigator.standalone === true;
};

// Get install type
export const getInstallType = () => {
  if (isPWAInstalled()) return 'pwa';
  if (window.navigator.standalone) return 'ios-standalone';
  return 'browser';
};
